import React, {Component} from 'react';
import {TYPE_MAP,TYPE_MAP_VIEW,WELL_CHOSEN_MAP} from '../../../utils/questionType';
import {Rate,Tooltip} from 'antd';
import {ONLINESTATUS} from '../../../utils/questionManageType';
import Footer from '../exercise/Footer';

const $ = require('$');
const MathQuill = require('MathQuill');

const MQ = MathQuill.getInterface(2);

class Question extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    }
    toggleAnswer = (val, e) => {
        // val && cnzz.statistics('PC端作业详情页', 2, '展开答案'); /** 打点统计 */
        e.stopPropagation();
        this.setState({visible: val});
    };
    componentDidMount() {
        $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            })
        $('.math_reading', this.refs.viewer).off();
        $('.inner_audio', this.refs.viewer) && $('.inner_audio', this.refs.viewer).off().on('click', () => {
            $('.math_reading', this.refs.viewer)[0].play();
            $('.inner_audio', this.refs.viewer).addClass('inner-audio-play');
        });
        $('.math_reading', this.refs.viewer) && $('audio', this.refs.viewer).bind('ended', () => {
            $('.inner_audio', this.refs.viewer).removeClass('inner-audio-play');
        });
        if(this.props.data.subject==='0'){
            this.setState({visible:true})  //数学题默认答案显示
        }
    }


    componentDidUpdate() {
        $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            });
        $('.math_reading', this.refs.viewer).off();
        $('.inner_audio', this.refs.viewer) && $('.inner_audio', this.refs.viewer).off().on('click', () => {
            $('.math_reading', this.refs.viewer)[0].play();
            $('.inner_audio', this.refs.viewer).addClass('inner-audio-play');
        });
        $('.math_reading', this.refs.viewer) && $('audio', this.refs.viewer).bind('ended', () => {
            $('.inner_audio', this.refs.viewer).removeClass('inner-audio-play');
        });
    }

    createHtml = str => ({__html: str ? str : `&nbsp;`});

    parseMS=(time)=>{
        let mm = '00';
        let ss = '00';
        let ms = '000';
        let num = time%60000
        if(num>10000){
            ms = (''+num).slice(-3)
            ss = (''+num).slice(0,-3)
        }
        else if(num>1000){
            ms = (''+num).slice(-3)
            ss = ('0'+num).slice(0,-3)
        }
        else if(num>100){
            ms = ''+num
        }
        else if(num>10){
            ms = '0'+num
        }
        else if(num>0){
            ms = '00'+num
        }
        if((time/60000)>10){
            mm = ''+parseInt(time/60000)
        }
        else if((time/60000)>0){
            mm = '0'+parseInt(time/60000)
        }
        return mm+':'+ss+'.'+ms
    }
    render() {
        const {visible} = this.state;
        let originData = this.props.data;
        if(this.props.errorAnswer){originData.answer = this.props.errorAnswer}//题目检错页显示的是错的的答题答案

        const {num, children} = this.props;
        let data = originData;
        let videoStem = JSON.parse(data.stem)
        return (
            <div className="box-exercise" ref={'viewer'}>
                <div className="exercise-content">
                    {num!=='undefined'&&<div className="exercise-num"><p className="math_text">{`${num + 1}、`}</p></div>}
                    {/*<div className="exercise-con" dangerouslySetInnerHTML={this.createHtml(data.stem)}/>*/}
                    <div className="exercise-con" >
                        <div>
                            {videoStem.video_name}
                        </div>
                        <div>
                            封面图：
                            <div style={{textAlign:'center',position:'relative',overflow:'hidden',minHeight:160}}>
                                <div style={{position:'absolute',left:'0',border:'solid 1px #999',padding:'10px'}}>
                                    <div className={'video_cover_img_preview'} style={{textAlign:'left',position:'relative',width:120,minHeight:90}}>
                                        {
                                           videoStem.video_cover_img_4_3&&
                                            <img src={videoStem.video_cover_img_4_3} width={120}  controls="controls"/>
                                        }
                                    </div>
                                </div>
                                <div style={{position:'absolute',left:'180px',border:'solid 1px #999',padding:'10px'}}>
                                    <div className={'video_cover_img_preview'} style={{textAlign:'left',position:'relative',width:160,minHeight:90}}>
                                        {
                                            videoStem.video_cover_img_16_9&&
                                            <img src={videoStem.video_cover_img_16_9} width={160}  controls="controls"/>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            视频：
                            <div style={{textAlign:'center',position:'relative',overflow:'hidden',minHeight:160}}>
                                <div style={{position:'absolute',left:'0',border:'solid 1px #999',padding:'10px'}}>
                                    <div className={'video_cover_img_preview'} style={{textAlign:'left',position:'relative',width:160,minHeight:120}}>
                                        {
                                            videoStem.video_url&&
                                            <video src={videoStem.video_url} width={160}  controls="controls">您的浏览器不支持</video>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            音频：
                            <div style={{textAlign:'center',position:'relative',overflow:'hidden',minHeight:100}}>
                                <div style={{position:'absolute',left:'0',padding:'10px'}}>
                                    <div className={'video_cover_img_preview'} style={{textAlign:'left',position:'relative',width:160,minHeight:120}}>
                                        {
                                            videoStem.video_bgm&&
                                            <audio  src={videoStem.video_bgm} controls="controls">您的浏览器不支持</audio>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div style={{marginBottom:10}}>
                                台词：
                            </div>

                            {

                                data.sub_list&&data.sub_list.length&&
                                data.sub_list.map((item, key) =>{
                                    item.videoStem = JSON.parse(item.stem)
                                    return <div key={key} style={{marginBottom:20}}>
                                        <div style={{fontSize:14,color:'#999'}}>

                                            {this.parseMS(item.videoStem.start_time)} - {this.parseMS(item.videoStem.end_time)}&nbsp;&nbsp;
                                            <span style={{display:'inline-block',width:90}}>
                                                {item.videoStem.role}
                                            </span>
                                            <div>

                                            </div>
                                        </div>

                                        <div style={{fontSize:14}}>
                                            <div style={{marginBottom:10}}>
                                                {item.videoStem.english_read}
                                            </div>
                                            <div>
                                                {item.videoStem.chinese_text}
                                            </div>
                                        </div>
                                    </div>
                                }

                            )

                            }
                        </div>
                    </div>

                </div>
                <div className="exercise-footer">
                    {
                        visible &&
                        <div className="footer-hide relative">
                            <div>
                                <div className="inline-block"><span style={{fontSize: 14}}>{this.props.errorAnswer?'错误答案：':'正确答案：'}</span></div>
                                <div className="inline-block" style={{width: '80%'}}>
                                    {/*<span style={{fontSize: 14}} dangerouslySetInnerHTML={this.createHtml(data.answer)}/>*/}
                                </div>
                            </div>
                            {
                                data.explain && <div>
                                    <div className="inline-block"><span style={{fontSize: 14}}>答案解析：</span></div>
                                    <div className="inline-block">
                                        <span style={{fontSize: 14}} dangerouslySetInnerHTML={this.createHtml(data.explain)}/>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    <div className="footer-show relative">
                        <Footer {...this.props} obj={originData} subject={this.props.data.subject}>
                            {
                                this.props.canShowAnswer ?
                                    <button
                                        className="question-btn"
                                        onClick={(e) => this.toggleAnswer(!visible,e)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null
                            }

                        </Footer>
                    </div>
                </div>
            </div>


        )
    }
}


export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/videodubbing/viewForView.js